<template>
  <v-row>
    <CreateEditRuleDialog v-model="isCreateEditActionDialogVisible"
                            :method="method"
                            :selected-rule-id="selectedRuleId"
                            @getRules="getRules()" />
    <v-col cols="12" class="d-flex justify-space-between align-center py-0">
      <span class="kbDarkBlueText--text d-block text-h5 font-weight-regular">
        {{ $t('general.sequencesRules') }}
      </span>

      <v-btn color="mainButtons"
             dark
             @click="showCreateRuleDialog()">
        {{ $t('general.newRule') }}
      </v-btn>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-data-table
        fixed-header
        :headers="tableHeaders"
        :height="dataTableHeight"
        :items="sequencesRules"
        :loading="loadingActions"
        :options.sync="options"
        :footer-props="{
            'items-per-page-text': `${$t('general.sequencesRules')} ${$t('general.perPage')}`,
            'items-per-page-options': [50, 100, 200]
          }"
        :server-items-length="totalSequencesRules"
        class="elevation-2 mt-4"
        :must-sort="false">
        <template v-slot:item="{ item }">
          <tr class="kbDarkBlueText--text">
            <td>
              <div>
                <span class="kbDarkBlueText--text font-weight-bold text-capitalize">
                  {{ item.name }}
                </span>
              </div>
            </td>

            <td>
              <div class="d-flex align-center justify-center">
                <v-switch color="kbBlue"
                          readonly
                          v-model="item.isGlobal" />
              </div>
            </td>

            <td>
              <div class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="kbDarkBlueText"
                           icon
                           @click="editRule(item.id)"
                           v-on="on">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.editRule') }}</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row>
            <v-col
              class="text-center"
              v-if="loadingActions"
              cols="12"
            >{{ $t('general.loading') }} {{ $t('general.rules') }}</v-col>
            <v-col
              class="red--text text-center"
              v-else
              cols="12"
            >{{ $t('general.noRulesCreated') }}</v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import CreateEditRuleDialog from '@/pages/App/Sequences/Rules/dialogs/CreateEditRule/CreateEditRule'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
export default {
  components: { CreateEditRuleDialog },
  computed: {
    ...mapState({
      sequencesRules: state => state.sequences.sequencesRules,
      totalSequencesRules: state => state.sequences.totalSequencesRules
    }),
    tableHeaders () {
      return [
        { text: this.$t('general.name'), value: 'name', align: 'left', sortable: true },
        { text: this.$t('general.isGlobal'), value: 'isGlobal', align: 'center', sortable: true },
        { text: this.$t('general.actions'), value: '', align: 'center', sortable: false }
      ]
    }
  },
  created () {
    this.getRules()
  },
  data () {
    return {
      isCreateEditActionDialogVisible: false,
      loadingActions: false,
      method: 'create',
      options: {},
      selectedRuleId: ''
    }
  },
  methods: {
    editRule (ruleId) {
      this.selectedRuleId = ruleId
      this.method = 'edit'
      this.isCreateEditActionDialogVisible = true
    },
    async getRules () {
      try {
        this.loadingActions = true
        await this.$store.dispatch('getSequencesRules', { appId: this.$store.getters.appUuid })
        this.loadingActions = false
      } catch (e) {
        notifications.error(e)
        this.loadingActions = false
      }
    },
    showCreateRuleDialog () {
      this.method = 'create'
      this.selectedRuleId = ''
      this.isCreateEditActionDialogVisible = true
    }
  },
  mixins: [ModuleTableHeight]
}
</script>
